import { useStyles, Button } from '@archipro-design/aria';
import { CloseLine } from '@archipro-design/icons';
import * as S from './FilterContainer.desktop.style';
import type { FilterContainerProps } from '~/modules/search/components/filter-drawer/FilterContainer';

const FilterContainerDesktop = (props: FilterContainerProps) => {
    const {
        primaryButton,
        secondaryButton,
        disabled,
        children,
        onClose,
        hideCloseButton,
    } = props;
    const { css } = useStyles();
    return (
        <div className={`${css(S.RootContainer)} filterContainer`}>
            <div className={css(S.ContentContainer)}>{children}</div>
            {!hideCloseButton && (
                <Button
                    className="closeButton"
                    disabled={disabled}
                    onClick={(e) => onClose?.(e)}
                    size={24}
                    color="grey"
                    variables={{
                        buttonPadding: 12,
                        iconPadding: 0,
                        buttonRadius: '50%',
                    }}
                    icon={<CloseLine />}
                />
            )}
            {(primaryButton || secondaryButton) && (
                <div className={css(S.BottomButtonsContainer)}>
                    {secondaryButton && (
                        <Button
                            transparent
                            size={24}
                            variables={{ buttonPadding: 0 }}
                            {...secondaryButton}
                            key="secondaryButton"
                            disabled={disabled}
                        />
                    )}
                    {primaryButton && (
                        <Button
                            size={24}
                            fluid
                            variables={{ buttonPadding: 24 }}
                            {...primaryButton}
                            key="primaryButton"
                            disabled={disabled}
                        />
                    )}
                </div>
            )}
        </div>
    );
};

export default FilterContainerDesktop;
